import Link from "next/link";

import { ExternalLinkIcon } from "@/components/icons/externalLink.icon";

import { appendQueryString } from "@/utils/url.util";

import type { MobileMenuLinkItem } from "./siteHeaderMobileMenuContent.utils";

export const SiteHeaderMobileMenuLink = ({
  item,
}: SiteHeaderMobileMenuLinkProps) => {
  if (!item.link.url) return null;
  const opensInNewTab = Boolean(item.link.openInNewTab);

  return (
    <li>
      <Link
        className="flex w-full items-center py-4 text-left font-bold tracking-wider"
        href={
          appendQueryString(item.link.url, item.link.queryString) ??
          item.link.url
        }
        target={opensInNewTab ? "_blank" : undefined}
        rel={opensInNewTab ? "noopener noreferrer" : undefined}
        data-testid="site-header-mobile-menu-link">
        {item.label}
        {opensInNewTab ? (
          <ExternalLinkIcon
            width={14}
            height={14}
            className="ml-1 inline-block align-middle"
            data-testid="site-header-mobile-menu-external-icon"
            aria-hidden
          />
        ) : null}
      </Link>
    </li>
  );
};

export type SiteHeaderMobileMenuLinkProps = {
  item: MobileMenuLinkItem;
};
